import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"

export enum Weight {
  W500 = "w500",
}

interface LinkUnderlineProps {
  className?: string
  children: string | React.ReactNode
  weight?: Weight
}

const LinkUnderline: React.FC<LinkUnderlineProps> = ({
  className,
  children,
  weight,
}) => {
  return (
    <span
      className={cx({
        [styles.linkUnderline]: true,
        [styles[weight]]: weight,
        [className]: !!className,
      })}
    >
      {children}
    </span>
  )
}

export default LinkUnderline
